import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { createForm } from 'rc-form';
import { Grid, Typography, Button, Card, CardContent } from '@material-ui/core';
import AddSharp from '@material-ui/icons/AddSharp';

import { selectApplicationSettings } from 'Console/data/applicationDetail/settings/SettingsSelector';

import Breadcrumb from 'Console/components/common/Breadcrumb';
import DrawerWrapper from 'Console/components/common/drawer/DrawerWrapper';
import SegmentsTable from 'Console/components/applications/detail/segments/SegmentsTable';
import CreateNewSegment from 'Console/components/applications/detail/segments/CreateNewSegment';
import Loading from 'Console/components/common/loading/Loading';

import { handleDrawerWrapperToggle } from 'Console/data/app/actions';
import {
    fetchSegments,
    createNewSegment,
    editSegment,
} from 'Console/data/applicationDetail/segments/actions';
import { pushNotificationToStack } from 'Console/data/notification/actions';
import {
    selectSegmentListData,
    selectSegmentsListDataError,
    selectSegmentsListDataIsLoading,
} from 'Console/data/applicationDetail/segments/selectors';
import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
    },
    header: {
        paddingBottom: theme.typography.pxToRem(28),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    unassingBtn: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        marginRight: '1.3rem',
        '& :hover': {
            color: '#00000061',
        },
    },
    tableWrapper: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            width: window.innerWidth * 0.7,
            overflow: 'scroll',
        },
    },
    button: {
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            marginTop: theme.typography.pxToRem(15),
        },
    },
});

class ApplicationSegments extends Component {
    state = {
        segmentToEdit: null,
    };

    componentDidMount() {
        const { fetchSegments } = this.props;
        fetchSegments();
    }

    handleSegmentClick = (segment) => () => {
        const { handleDrawerWrapperToggle } = this.props;
        this.setState({ segmentToEdit: segment });
        handleDrawerWrapperToggle(true);
    };

    handleUnAssign = () => {
        console.log('unasign callback');
    };

    openDrawerWrapper = () => {
        const { handleDrawerWrapperToggle } = this.props;
        handleDrawerWrapperToggle(true);
    };

    closeDrawerWrapper = () => {
        const { handleDrawerWrapperToggle } = this.props;
        this.setState({ segmentToEdit: null });
        handleDrawerWrapperToggle(false);
    };

    createOrUpdateSegment = () => {
        const {
            form: { getFieldsValue, getFieldError, getFieldsError },
            createNewSegment,
            editSegment,
            intl,
        } = this.props;
        const { segmentToEdit } = this.state;
        const newSegment = getFieldsValue([
            'active',
            'kind',
            'valueTypes',
            'name',
            'systemKey',
            'description',
        ]);
        const errors = [];

        for (const error in getFieldsError()) {
            if (getFieldError(error)) {
                errors.push(getFieldError(error));
            }
        }

        if (errors.length > 0) {
            return;
        }

        if (segmentToEdit) {
            editSegment(segmentToEdit, newSegment, {
                success: `${intl.formatMessage({ id: 'Notification.edit.segment' })}`,
                fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
            });
        } else {
            createNewSegment(newSegment, {
                success: `${intl.formatMessage({ id: 'Notification.create.segment' })}`,
                fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
            });
        }

        this.closeDrawerWrapper();
    };

    render() {
        const {
            classes,
            intl,
            isDrawerWrapperShown,
            applicationDetail: { data },
            form,
            isSegmentsLoading,
            hasSegmentsError,
            segments,
        } = this.props;
        const { segmentToEdit } = this.state;

        if (hasSegmentsError) {
            const { pushNotificationToStack } = this.props;
            pushNotificationToStack(intl.formatMessage({ id: 'Notification.fail.loadData' }));
            return null;
        }

        if (isSegmentsLoading) {
            return <Loading />;
        }

        return (
            <Grid container className={classes.root}>
                <Grid>
                    <DrawerWrapper
                        title={
                            segmentToEdit
                                ? intl.formatMessage({ id: 'Segments.editSegmentTitle' })
                                : intl.formatMessage({ id: 'Segments.createSegmentTitle' })
                        }
                        isShown={isDrawerWrapperShown}
                        onClose={this.closeDrawerWrapper}
                        displayButtons={false}
                    >
                        <CreateNewSegment segmentToEdit={segmentToEdit} form={form} />

                        <Grid container justify="center" alignItems="center" direction="row">
                            <Typography>
                                <Button
                                    id="yeself-cancel-button"
                                    style={{ color: 'rgba(0, 0, 0, 0.38)', marginRight: '1.3rem' }}
                                    onClick={this.closeDrawerWrapper}
                                >
                                    {intl.formatMessage({ id: 'Buttons.cancel' })}
                                </Button>
                            </Typography>

                            {segmentToEdit && (
                                <Typography>
                                    <Button
                                        id="yeself-unassign-button"
                                        onClick={this.handleUnAssign}
                                        className={classes.unassingBtn}
                                    >
                                        {intl.formatMessage({ id: 'Buttons.unassign' })}
                                    </Button>
                                </Typography>
                            )}

                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.createOrUpdateSegment}
                                >
                                    {segmentToEdit
                                        ? intl.formatMessage({ id: 'Buttons.update' })
                                        : intl.formatMessage({ id: 'Buttons.create' })}
                                </Button>
                            </Typography>
                        </Grid>
                    </DrawerWrapper>
                </Grid>

                <Grid item xs={12}>
                    <Breadcrumb
                        paths={[
                            {
                                to: ROUTES.APPLICATIONS,
                                text: intl.formatMessage({ id: 'Navigation.applications' }),
                            },
                            {
                                text: data.name,
                            },
                        ]}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container alignItems="flex-end">
                        <Grid container>
                            <Grid
                                className={classes.header}
                                container
                                justify="space-between"
                                alignItems="flex-end"
                            >
                                <Grid item>
                                    <Typography variant="h6">
                                        {intl.formatMessage({
                                            id: 'Applications.navigation.detail.segments',
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography className={classes.button}>
                                        <Button
                                            id="yeself-button"
                                            variant="contained"
                                            color="primary"
                                            onClick={this.openDrawerWrapper}
                                        >
                                            <AddSharp fontSize="small" />
                                            {intl.formatMessage({ id: 'Buttons.createSegment' })}
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid className={classes.tableWrapper}>
                    <Card>
                        <CardContent>
                            <SegmentsTable segments={segments} onRowClick={this.handleSegmentClick} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(
    injectIntl(
        connect(
            (state) => ({
                isDrawerWrapperShown: state.app.drawerWrapperIsShown,
                applicationDetail: selectApplicationSettings(state),
                segments: selectSegmentListData(state),
                isSegmentsLoading: selectSegmentsListDataError(state),
                hasSegmentsError: selectSegmentsListDataIsLoading(state),
            }),
            {
                handleDrawerWrapperToggle,
                createNewSegment,
                fetchSegments,
                pushNotificationToStack,
                editSegment,
            }
        )(createForm()(ApplicationSegments))
    )
);
